export default function scrollRelatedContent() {
  // Change placement of related content depending on
  // what's visible in the UI

  const relatedContent = document.getElementsByClassName("related-content");
  const relatedContentArr = [...relatedContent];

  if (relatedContentArr.length) {
    let prevScrollPos = window.pageYOffset;

    const secondaryNav = document.querySelector(".secondary-navigation");

    if (secondaryNav) {
      relatedContentArr.forEach((content) => {
        content.classList.add("--with-nav");
      });
    }

    const addRemoveScrollClass = () => {
      if (document.body.classList.contains("is-scrolling")) {
        return;
      }

      let currentScrollPos = window.pageYOffset;

      relatedContentArr.forEach((content) => {
        if (prevScrollPos > currentScrollPos) {
          content.classList.remove("scroll-top");
        } else {
          content.classList.add("scroll-top");
        }
      });

      prevScrollPos = currentScrollPos;
    };

    window.addEventListener("scroll", addRemoveScrollClass);
  }
}
